const getCreatorProducts = () => {};

export default getCreatorProducts;
